<template>
  <RevDialog
    :close-button-label="i18n(translations.doneSection)"
    :name="MODAL_NAME"
    :title
  >
    <template #header>{{ title }}</template>
    <template #body>
      <div class="mt-20">
        <slot name="description" />
      </div>
      <div>
        <RevTag
          class="mr-8 mt-16"
          :label="i18n(translations.toDoSection)"
          variant="primary"
        />
      </div>
      <slot name="to-do" />

      <div class="body-1-bold mt-16">{{ i18n(translations.doneSection) }}</div>
      <div class="mb-20"><slot name="done" /></div>
    </template>
    <template #footer="{ close }">
      <RevButton
        class="mb-8"
        full-width="always"
        variant="primary"
        @click="close"
      >
        {{ buttonLabel }}
      </RevButton>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { onMounted } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { openModal } from '@ds/components/ModalBase'
import { RevTag } from '@ds/components/Tag'

import { MODAL_NAME, ONBOARDING_QUERY_VALUE } from './Onboarding.constants'
import translations from './Onboarding.translations'

defineProps<{
  title: string
  buttonLabel: string
}>()

const i18n = useI18n()

const route = useRoute()

onMounted(() => {
  if (route.query.onboarding === ONBOARDING_QUERY_VALUE) {
    openModal(MODAL_NAME)
  }
})
</script>
